<template>
  <div class="row">
    <ol class="breadcrumb">
      <li>
        <router-link :to="'/'">
          Início
        </router-link>
      </li>
      <li v-for="{ named_link, link, label } in links" :key="label">
        <router-link
          v-if="named_link || link"
          :to="named_link ? named_link : link"
        >
          {{ label }}&nbsp;
        </router-link>
        {{ named_link || link ? '' : label }}
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    links: {
      type: Array,
      default: () => [
        {
          named_link: '',
          link: '',
          label: ''
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Breadcrumb.vue